var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "DrawerAccordion",
    {
      staticClass: "sidemenu-overview-note",
      attrs: { id: "note", title: _vm.$t.__("common.labels.note") }
    },
    [
      _vm.permissionsToEdit
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside.stop",
                  value: _vm.submitNote,
                  expression: "submitNote",
                  modifiers: { stop: true }
                }
              ]
            },
            [
              _c(
                "div",
                [
                  _c("RichText", {
                    ref: "refNotesRichText",
                    staticClass: "notes-richtext",
                    attrs: {
                      placeholder: _vm.$t.__("common.actions.write_note"),
                      options: _vm.optionsRichText,
                      "is-custom": true,
                      "show-rich-text-menu": false
                    },
                    model: {
                      value: _vm.note,
                      callback: function($$v) {
                        _vm.note = $$v
                      },
                      expression: "note"
                    }
                  }),
                  _vm._v(" "),
                  _vm.richTextEditor
                    ? _c("RichTextMenu", {
                        staticClass: "notes-richtext-menu",
                        attrs: {
                          "editor-menu": _vm.richTextEditor,
                          options: _vm.optionsRichText
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.canImportOldNote
                ? _c("CompassPlainButton", {
                    staticClass: "mt-1 mb-1",
                    attrs: {
                      label: _vm.$t.__("overview.Overview.see_old_datas"),
                      size: "small",
                      "left-icon": "attachment"
                    },
                    on: {
                      click: function($event) {
                        return _vm.openDialog("import-old-note")
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sidemenu-overview-note__buttons" },
                [
                  _c("CompassButton", {
                    attrs: {
                      label: _vm.$t.__("common.actions.cancel"),
                      size: "small",
                      type: "secondary"
                    },
                    on: { click: _vm.cancelEditNote }
                  }),
                  _vm._v(" "),
                  _c("CompassButton", {
                    attrs: {
                      label: _vm.$t.__("common.actions.save"),
                      size: "small",
                      loading: _vm.isloading
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.submitNote($event)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _c("div", {
            staticClass:
              "sidemenu-overview-note__content typographies-paragraph-medium-regular",
            domProps: { innerHTML: _vm._s(_vm.note) }
          })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }